module.exports = {"TXTCLI_Back":{"id":"TXTCLI_Back","defaultMessage":"Tilbage","flags":["TRACK"],"track":"Back"}}